import { ITourPoint } from "contexts/RequestQuoteContext";
import { EVehiculeType, Stop, TemplateStop } from "generated/graphql";
import { isFieldWithValue } from "../shared/utils";

export const isValidPoint = (point: ITourPoint) => isFieldWithValue(point?.address?.place_id);

const isVehicleTruckChoosen = (vehicle: EVehiculeType) => vehicle?.includes("TRUCK");

export const isAllStopsTourValid = (stops: ITourPoint[]) => stops?.every(isValidPoint);

export const isVehicleChoosen = (vehicle: EVehiculeType, truckType: EVehiculeType) =>
  isFieldWithValue(vehicle) ? (isVehicleTruckChoosen(vehicle) ? Boolean(isFieldWithValue(truckType)) : true) : false;

export const extractRegions = (templateStops: TemplateStop[]) =>
  templateStops
    ?.map((stop) => stop?.address?.region?.replace("Region", "").trim())
    .reduce((unique, item) => (unique.includes(item) ? unique : [item, ...unique]), [])
    .sort();

export const parseTourStops = (templateStops: TemplateStop[]): Stop[] => {
  return templateStops?.reduce((stops, stop) => [...stops, stop], []);
};
